import React, { useState, useEffect } from 'react'
import { Form, Cascader } from 'antd-mobile';
import { FORM_NAME } from 'utils/constant/formName';

/**
 * 户籍地址选择框
 * @param {
 *  item:对应的表单模板
 *  setFormInfo:向传给接口的对象中新增对应表单数据
 *  getAreaObj:根据传入的key,获取数据,插入到areaContent中
 *  areaContent:联级选择框内数据
 * } props
 * @returns
 */
export function BpmFormNationPicker(props) {
  const { postName, label, required, message, chooseNum, defaultValue } = props.item
  const { setFormInfo,formName, areaContent, setAreaContent, getAreaObj, form } = props

  const [visible, setVisible] = useState(false)
  const [options, setOptions] = useState([])


  /** 修改表单储存的信息 */
  function updateFormInfo(arr, value) {
    for (let i = 0; i < arr.length; i++) {
      value[i] && setFormInfo(arr[i], value[i])
    }
  }

  /** 选中选择框选项 */
  function handleOnSelect(value, extend) {
    const nationInfo = ['FResidProvince', 'FRESIDCITY', 'FRESIDCOUNTY', 'FRESIDTOWN', 'FRESIDVILLAGE']
    const permanentInfo = ['FPERPROVINCE', 'FPERCITY', 'FPERCOUNTY', 'FPERTOWN', 'FPERVILLAGE']

    setTimeout(() => {
      getAreaObj(extend.items, areaContent, setAreaContent)
      if (label === '户籍地址' || postName === 'permanent118') {
        updateFormInfo(nationInfo, value)
      } else if (label === '常住地址' || postName === 'address118') {
        updateFormInfo(permanentInfo, value)
      } else {
        const newValue = value[value.length - 1]
        setFormInfo(postName, newValue)
      }
    })
  }



  /** 是否弹出选择框 */
  function handleVisibleClick(state) {
    setVisible(state)
  }


  /** 显示在表单上字段 */
  function onValue(items) {
    if (items.every(item => item === null)) {
      return '请选择'
    } else if (label !== '户籍地址' && label !== '常住地址') {
      return items[items.length - 1].label
    } else {
      return items.map(item => item?.label)
    }
  }

  /** 自定义自定义校验 */
  const validate = {
    rules: [
      {
        required: required,
        message: required ? '' : message,
      },
      {
        validator: (_, value) => {
          if (required && !value) {
            return Promise.reject(message)
          }
          if (formName === FORM_NAME.AFFIRMEMPLOY && form.getFieldValue('address')[1] === 243) { // 就困表单，不能选择厦门
            return Promise.reject('请选择非厦门地区')
          }
          if (required && chooseNum && value.length !== chooseNum) {
            switch (value.length) {
              case 1:
                return Promise.reject('请选择省份、城市、区县、乡镇、村')
              case 2:
                return Promise.reject('请选择区县、乡镇、村')
              case 3:
                return Promise.reject('请选择乡镇、村')
              case 4:
                return Promise.reject('请选择村')
              default:
                return Promise.reject('请选择省份、城市、区县、乡镇、村')
            }
          }
          return Promise.resolve()
        }
      }
    ]
  }

  document.addEventListener('click', (e) => {
    // 阻止遮罩层的点击事件冒泡
    if (e.target.className === 'adm-mask') {
      e.stopPropagation()
    }
  }, true)

  useEffect(() => {
    // 设置默认值
    if (defaultValue) {
      const newAreContent = areaContent
      const newDefaultOptions = newAreContent.filter(item => item.value === defaultValue)
      setOptions(newDefaultOptions)
    } else {
      setOptions(areaContent)
    }
  }, [defaultValue, areaContent])



  return (
    <Form.Item
      name={postName}
      label={label}
      trigger='onConfirm'
      onClick={() => handleVisibleClick(true)}
      rules={validate.rules}
    //initialValue={[defaultValue]}
    >
      <Cascader
        options={options}
        visible={visible}
        onClose={() => handleVisibleClick(false)}
        onSelect={(value, extend) => handleOnSelect(value, extend)}
      >
        {items => onValue(items)}
      </Cascader>
    </Form.Item>
  )
}